<p-toast></p-toast>

<div class="bank-details-container">

    <!-- Hidden on Small screens -->
    <!-- Visible on Small screens -->
    <div class="block md:hidden">
        <div *ngIf="loading">
            <div id="pause" class="flex align-items-center justify-content-center">
                <div id="spinner"></div>
            </div>
        </div>
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                    <!-- <mat-icon>menu</mat-icon> -->
                </div>
                <div class="header">
                    <p>{{'WELOCOME_TO'| translate}}</p>
                    <p>{{'MICADA_MOBILE_APPLICATION'| translate}}</p>
                </div>
                <div class="subheader">
                    <p> {{'EFFICIENT_AND_ELEGANT_WAY_TO_VERIFY_SITE'| translate}}</p>
                </div>
            </div>
        </div>
        <div style="padding: 0 1em;">
            <p-toolbar styleClass="mb-4" reflow="true">
                <ng-template pTemplate="left"></ng-template>
                <ng-template pTemplate="right">
                    <button *ngIf="mobileFarmerUHBVNpvData.length > 0" (click)="menu.toggle($event)" pButton pRipple
                        label="{{'EXPORT'| translate}}" icon="pi pi-upload" class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}"
                        icon="pi pi-refresh" class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </ng-template>
            </p-toolbar>
            <p-card class="mobile-card">
                <div class="mobile_search">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="mobileSearch($any($event.target).value)"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </p-card>
            <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of mobileFarmerUHBVNpvData"
                (click)="selectPreSurveyData(item)"
                [style]="{'color': 'black', 'background-color': rowBackgroundColor(item)}">
                <!-- <table cellspacing="1"> -->
                <table cellspacing="10">
                    <tr>
                        <td class="fontXl"><b>{{'APP_ID'| translate}}</b></td>
                        <td class="fontXl"><b>{{item.AppId}}</b>
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FARMER_NAME'| translate}}</b></td>
                        <td>
                            {{item.Farmer_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'MOBILE_NO'| translate}}</b></td>
                        <td>
                            {{item.FarmerMobile}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FATHERS_NAME'| translate}}</b></td>
                        <td>
                            {{item.Father_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VILLAGE'| translate}}</b></td>
                        <td>
                            {{item.VillageName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VENDOR_NAME'| translate}}</b></td>
                        <td>
                            {{item.VendorFullName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'PROGRAMME_NAME'| translate}}</b></td>
                        <td>
                            {{item.Program_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'KILLA_NO'| translate}}</b></td>
                        <td>
                            {{item.KillaNo}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'TOTAL_AREA_IN_ACRE'| translate}}</b></td>
                        <td>
                            {{item.AreaAcre}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FINANCIAL_YEAR'| translate}}</b></td>
                        <td>
                            {{item.Fin_Year}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'Status'| translate}}</b></td>
                        <td>
                            {{item.JE_Status}}
                        </td>
                    </tr>
                    <!-- <tr>
                        <td><b>{{'VIEW_APPLICATION' | translate}}</b></td>
                        <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                            class="p-button-rounded p-button-accent mr-1 btnSize"
                            (click)="selectViewApplication(item,item?.Status_Ar)"></button></td>
                    </tr> -->
                    <tr>
                        <td><b>{{'ESTIMATION_ACTION'| translate}}</b></td>
                        <td
                            *ngIf="!(isJeLogin && item?.JE_Status == 'Approved' || isXenLogin && item?.XEN_Status == 'Done')">
                            <button pButton pRipple type="button" pTooltip="Add-Estimation" icon="pi pi-plus"
                                class="p-button-rounded p-button-text" (click)="addEstimation(item)"></button>
                        </td>
                        <td
                            *ngIf="(isJeLogin && item?.JE_Status == 'Approved' || isXenLogin && item?.XEN_Status == 'Done')">
                            <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                (click)="updateEstimation(item)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"></button>
                        </td>
                    </tr>
                </table>
            </p-card>
            <!-- <table>
                <tr *ngIf="mobileFarmerUHBVNpvData.length == 0">
                    <td colspan="7">No Data found.</td>
                </tr>
            </table> -->
        </div>
    </div>

    <div class="grid hidden md:block mt-2">
        <div class="col-12">
            <div class="card">
                <div class="dashboardTable">
                    <p-table #farmerPreEstimateSurveyTable [value]="farmerUHBVNpvData" dataKey="id" [rows]="10"
                        [paginator]="true" [globalFilterFields]="[
                        'AppId',
                        'Farmer_Name',
                        'FarmerMobile',
                        'Father_Name',
                        'VillageName',
                        'VendorFullName',
                        'Program_Name',
                        'KillaNo',
                        'AreaAcre',
                        'Fin_Year',
                        'JE_Status'
                        ]" responsiveLayout="scroll" [rowHover]="true" sortMode="multiple"
                        [multiSortMeta]="multiSortMeta"
                        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                        [showCurrentPageReport]="true" [loading]="loading">
                        <!-- <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="farmerPreEstimateSurveyTable.filterGlobal($any($event.target).value, 'contains')"
                                        placeholder="{{'SEARCH'| translate}}" />
                                </span>
                            </div>
                        </ng-template> -->
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <!-- Left side -->
                                <div class="col-5">
                                    <h5 class="m-0 table-header-text">{{'Application for PV'| translate}}</h5>
                                </div>
                                <!-- Middle section for buttons -->
                                <div class="col-4 d-flex  justify-content-between">
                                    <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                                        class="p-button-help mx-1"></button>
                                    <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
                                        class="p-button-info mx-1"></button>
                                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                                </div>
                                <!-- Right side for search -->
                                <div class="col-3 d-flex align-items-center justify-content-end">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="farmerPreEstimateSurveyTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="AppId">{{'APP_ID'| translate}}
                                    <!-- <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                                    <p-sortIcon field="AppId"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="Farmer_Name">{{'FARMER_NAME'| translate}}
                                    <!-- <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                                    <p-sortIcon field="appID"></p-sortIcon> -->
                                </th>
                                <!-- <th pSortableColumn="AssignedDate">{{'DATE_OF_SUBMIT'| translate}}
                                    <p-columnFilter type="text" field="registerationDate_filter" display="menu"></p-columnFilter>
                                    <p-sortIcon field="AssignedDate"></p-sortIcon>
                                </th> -->
                                <!-- <th pSortableColumn="LastSubmittedDate">{{'DATE_OF_RESUBMIT'| translate}}
                                    <p-columnFilter type="text" field="registerationReassignDate_filter" display="menu"></p-columnFilter>
                                    <p-sortIcon field="LastSubmittedDate"> </p-sortIcon>
                                </th> -->
                                <th pSortableColumn="FarmerMobile">{{'MOBILE_NO'| translate}}
                                    <!-- <p-columnFilter type="text" field="FarmerMobile" display="menu"></p-columnFilter>
                                    <p-sortIcon field="FarmerMobile"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="Father_Name">{{'FATHERS_NAME'| translate}}
                                    <!-- <p-columnFilter type="text" field="Father_Name" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Father_Name"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="VillageName">{{'VILLAGE'| translate}}
                                    <!-- <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                                    <p-sortIcon field="village"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="VendorFullName">{{'VENDOR_NAME'| translate}}
                                    <!-- <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                                    <p-sortIcon field="VendorName"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="Program_Name">{{'PROGRAMME_NAME'| translate}}
                                    <!-- <p-columnFilter type="text" field="ProgName" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ProgName"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="KillaNo">{{'KILLA_NO'| translate}}
                                    <!-- <p-columnFilter type="text" field="KillaNo" display="menu"></p-columnFilter>
                                    <p-sortIcon field="KillaNo"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="AreaAcre">{{'TOTAL_AREA_IN_ACRE'| translate}}
                                    <!-- <p-columnFilter type="text" field="AreaAcre" display="menu"></p-columnFilter>
                                    <p-sortIcon field="AreaAcre"></p-sortIcon> -->
                                </th>
                                <th pSortableColumn="Fin_Year">{{'FINANCIAL_YEAR'| translate}}
                                    <p-columnFilter type="text" field="Fin_Year" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Fin_Year"></p-sortIcon>
                                </th>
                                <th pSortableColumn="JE_Status">{{'STATUS'| translate}}
                                    <p-columnFilter type="text" field="JE_Status" display="menu"></p-columnFilter>
                                    <p-sortIcon field="JE_Status"></p-sortIcon>
                                </th>
                                <!-- <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th> -->
                                <th pSortableColumn="">{{'ACTION'| translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                                <td>{{product.AppId}}</td>
                                <td>{{product.Farmer_Name}}</td>
                                <td>{{product.FarmerMobile}}</td>
                                <td>{{product.Father_Name}}</td>
                                <td>{{product.VillageName}}</td>
                                <td>{{product.VendorFullName}}</td>
                                <td>{{product.Program_Name}}</td>
                                <td>{{product.KillaNo}}</td>
                                <td>{{product.AreaAcre}}</td>
                                <td>{{product.Fin_Year}}</td>
                                <td *ngIf="isJeLogin">{{product.JE_Status}}</td>
                                <td *ngIf="isXenLogin">{{product.XEN_Status}}</td>
                                <!-- <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectViewApplication(product,product?.Status_Ar)"></button></td> -->
                                <td>
                                    <button
                                        *ngIf="(isJeLogin && product?.JE_Status == 'Pending'
                                        || isXenLogin && product?.JE_Status == 'Done' && product?.XEN_Status == 'Pending')"
                                        pButton pRipple type="button" pTooltip="" icon="pi pi-plus"
                                        class="p-button-rounded p-button-text"
                                        (click)="addEstimation(product)"></button>
                                    <button
                                        *ngIf="(isJeLogin && product?.JE_Status == 'Approved' && product?.XEN_Status == 'Pending' 
                                        || isXenLogin && product?.JE_Status == 'Done' && product?.XEN_Status == 'Approved')"
                                        pButton pRipple type="button" pTooltip="" (click)="updateEstimation(product)"
                                        icon="pi pi-pencil" class="p-button-rounded p-button-text"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex  justify-content-between flex-column ">
                                <!-- <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{appVerificationModel ? appVerificationModel.length : 0 }} {{'FOR_APPROVAL'| translate}}.
                                </p> -->
                                <div class="flex  justify-content-between flex-column ">
                                    <!-- <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}</div>
                                    <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY'| translate}}</div> -->
                                    <div class="flex">
                                        <div
                                            style="background-color:#b9ecb9 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                        </div>{{'Approved'| translate}}
                                    </div>
                                    <div class="flex">
                                        <div
                                            style="background-color:#f9cece ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                                        </div>{{'Not Approved'| translate}}
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="flex align-items-center justify-content-between">
                                {{'IN_TOTAL_THERE_ARE'| translate}} {{farmerUHBVNpvData ?
                                farmerUHBVNpvData.length : 0 }} {{'FARMER_PRE_SURVEY_ADDED'| translate}}.
                            </div> -->
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">No Data found.</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
    <!-- Hidden on small screens -->
</div>




<p-dialog header="" [(visible)]="displayUHBVNpvDialog" [modal]="true" [style]="{width: '85%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()">
    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedRow?.AppId
                    }}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    selectedRow?.Farmer_Name | uppercase }}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'PROG_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedRow?.Program_Name
                    }}</label></label>
        </div>
    </div>

    <div class="card field-content" style="margin-bottom: 5px;">
        <form [formGroup]="submitEstimateForm">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-3">
                    <label style="margin-right:4px;">{{'CROP_TYPE'| translate }}</label>
                    <p-dropdown [options]="cropTypeList" formControlName="cropType"
                        placeholder="{{'SELECT_CROP_TYPE'| translate}}" optionLabel="label" optionValue="data"
                        (ngModelChange)="getCropTypeName($event)">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.cropType.touched) && f.cropType.errors" class="invalid-feedback">
                        <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label style="margin-right:4px;">{{'CROP'| translate }}</label>
                    <p-dropdown [options]="cropBasedNames" formControlName="cropId"
                        placeholder="{{'SELECT_CROP'| translate}}" optionLabel="label" optionValue="data">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.cropId.touched) && f.cropId.errors" class="invalid-feedback">
                        <div *ngIf="f.cropId.errors.required">{{'CROP_IS_REQ'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label htmlFor="selectProgram">{{'MIS Installed'| translate}}</label>
                    <p-dropdown [options]="componentMasterList" formControlName="misInstalled"
                        optionLabel="Program_Name" optionValue="Program_Id"
                        placeholder="{{'Select MIS Installed'| translate}}" appendTo="body">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.misInstalled.touched) && f.misInstalled.errors"
                        class="invalid-feedback">
                        <div *ngIf="f.misInstalled.errors.required">{{'MIS Installed is required'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'KILLA_NO'| translate}}</label>
                    <input pInputText id="killNumber" type="text" formControlName="killNumber"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.killNumber.errors}"
                        placeholder="{{'KILLA_NO' | translate}}" />
                    <div *ngIf="(isSubmitted || f.killNumber.touched) && f.killNumber.errors" class="invalid-feedback">
                        <div *ngIf="f.killNumber.errors.required">{{'KILLA_NUMBER_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'Performa Quantity'| translate}}</label>
                    <input pInputText id="performaQunatity" type="text" formControlName="performaQunatity"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.performaQunatity.errors}"
                        placeholder="{{'Performa Quantity' | translate}}" />
                    <div *ngIf="(isSubmitted || f.performaQunatity.touched) && f.performaQunatity.errors"
                        class="invalid-feedback">
                        <div *ngIf="f.performaQunatity.errors.required">{{'Performa Quantity is required'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label htmlFor="selectProgram">{{'Status of Application'| translate}}</label>
                    <p-dropdown [options]="applicationStatusList" formControlName="appStatus" optionLabel="name"
                        optionValue="code" (onChange)="onSelectAppStatus($event)"
                        placeholder="{{'Select Status'| translate}}" appendTo="body">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.appStatus.touched) && f.appStatus.errors" class="invalid-feedback">
                        <div *ngIf="f.appStatus.errors.required">{{'MIS Installed is required'| translate}}</div>
                    </div>
                </div>

                <div *ngIf="isXenLogin" class="field col-12 md:col-3">
                    <label>{{'JE Remark'| translate}}</label>
                    <textarea id="description" formControlName="jePVRemarks" placeholder="{{'REMARKS'| translate}}"
                        pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
                </div>

                <div *ngIf="submitEstimateForm.value['appStatus'] == 1 && isJeLogin" class="field col-12 md:col-12">
                    <span>
                        <p-checkbox name="group1" value="true" formControlName="checkBoxRec" id="ch"
                            [ngClass]="{ 'ng-invalid ng-dirty': (isSubmitted || f.checkBoxRec.touched) && f.checkBoxRec.errors }"></p-checkbox>
                        <label htmlFor="consent" class="ml-2">{{'The MIS System (Drip/ Portable sprinkler/ Mini
                            sprinkler) in ' }} {{ selectedRow?.AreaAcre }} {{ ' acres at ' }} {{ selectedRow?.KillaNo }}
                            {{ ' killa no. has been found installed & operational. Therefore, it is recommended that the
                            MIS installation certificate as required by UHBVN may be issued.'}}</label>
                    </span>
                    <div *ngIf="(isSubmitted || f.checkBoxRec.touched) && f.checkBoxRec.errors"
                        class="invalid-feedback">
                        <div *ngIf="f.checkBoxRec.errors.required">{{'Click on checkbox'| translate}}</div>
                    </div>
                </div>

                <div *ngIf="submitEstimateForm.value['appStatus'] == 0 && isJeLogin" class="field col-12 md:col-12">
                    <label htmlFor="selectProgram">{{'The MIS System in '}} {{ selectedRow?.AreaAcre }} {{ ' acres at
                        '}} {{ selectedRow?.KillaNo }} {{ 'killa no. has been checked & following shortcomings have been
                        found'| translate}}</label>
                    <div class="flex flex-wrap gap-2">
                        <div *ngFor="let category of nonRecOptionList" class="field-checkbox">
                            <p-radioButton [inputId]="category.code" name="nonRecReason" [value]="category"
                                (onClick)="onSelectNonRecOption($event)" formControlName="nonRecReason"
                                [(ngModel)]="selectedNonRecOpt"></p-radioButton>
                            <label [for]="category.code" class="ml-1">
                                {{ category.name }}
                            </label>
                        </div>
                    </div>
                    <div *ngIf="(isSubmitted || f.nonRecReason.touched) && f.nonRecReason.errors"
                        class="invalid-feedback">
                        <div *ngIf="f.nonRecReason.errors.required">{{'MIS Installed Not Recommended reason required'|
                            translate}}</div>
                    </div>
                </div>

                <div *ngIf="submitEstimateForm.value['nonRecReason']?.code == 5 && isJeLogin"
                    class="field col-12 md:col-6">
                    <textarea id="description" formControlName="remarksNonRec" placeholder="{{'REMARKS'| translate}}"
                        pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
                    <div *ngIf="(isSubmitted || f.remarksNonRec.touched) && f.remarksNonRec.errors"
                        class="invalid-feedback">
                        <div *ngIf="f.remarksNonRec.errors.required">{{'MIS Installed Not Recommended remark required'|
                            translate}}</div>
                    </div>
                </div>
            </div>

        </form>
    </div>

    <div class="gps-coordinate-container">
        <div class="card block md:hidden" style="padding:0.5rem">
            <h5>{{'CAPTURE_GPS_COORDINATES' | translate}}</h5>
            <div *ngIf="geolocationsarray && geolocationsarray.length>0 || overlays.length>0" style="padding: 0 1em;">
                <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of geolocationsarray; let i=index">
                    <table cellspacing="10" style="margin-left: -12px;">
                        <tr (click)="selectPreSurveyData(item)">
                            <td><b>{{'CORNER_ID'| translate}}</b></td>
                            <td class="surveyEstimateTable"><b>{{item.CornerID}}</b>
                            </td>
                        </tr>
                        <tr>
                            <td><b>{{'LATITUDE'| translate}}</b></td>
                            <td class="surveyEstimateTable">{{item.lat}}</td>
                        </tr>
                        <tr>
                            <td><b>{{'LONGITUDE'| translate}}</b></td>
                            <td class="surveyEstimateTable">{{item.lng}}</td>
                        </tr>
                        <tr>
                            <td><b>{{'ACTIONS'| translate}}</b></td>
                            <td>
                                <button pButton pRipple type="button" icon="pi pi-times" (click)="onDelect(i)"
                                    class="p-button-rounded p-button-text p-button-danger"></button>
                            </td>
                        </tr>
                    </table>

                </p-card>
                <!-- <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays" (onOverlayDragEnd)="onDrag($event)"></p-gmap> -->
                <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays"></p-gmap>


                <div *ngIf="isJeLogin" class="my-2 proDataButton">
                    <p class="invalid-feedback"
                        *ngIf="geolocationsarray && geolocationsarray.length<4 && coordinateError">{{coordinateError}}
                    </p>
                    <button pButton pRipple type="submit" (click)="onCapture()"
                        label="{{'CAPTURE_GPS_COORDINATES'| translate}}" class="p-button-info mr-2 mb-2"></button>
                    <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation()"
                        label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                        class="p-button-info mr-2 mb-2"></button>
                </div>
            </div>
        </div>
        <div class="card hidden md:block">
            <h5>{{'CAPTURE_GPS_COORDINATES' | translate}}</h5>
            <div *ngIf="geolocationsarray && geolocationsarray.length>0 || overlays.length>0" class="dashboardTable">
                <p-table [value]="geolocationsarray" #geolocationsarrayTable dataKey="AppID" [rows]="10"
                    responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'CORNER_ID' | translate}}</th>
                            <th>{{'LATITUDE'| translate}}</th>
                            <th>{{'LONGITUDE'| translate}}</th>
                            <th>{{'ACTIONS'| translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                        <tr>
                            <td class="surveyEstimateTable">{{product.CornerID}}</td>
                            <td class="surveyEstimateTable">{{product.lat}}</td>
                            <td class="surveyEstimateTable">{{product.lng}}</td>
                            <td class="surveyEstimateTable">
                                <button pButton pRipple type="button" icon="pi pi-times" (click)="onDelect(rowIndex)"
                                    class="p-button-rounded p-button-text p-button-danger"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate}} {{geolocationsarray ?
                            geolocationsarray.length : 0 }} {{'CAPTURE_GPS_COORDINATES_ADDED' | translate}}.
                        </div>
                    </ng-template>
                </p-table>
                <!-- <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays" (onOverlayDragEnd)="onDrag($event)"></p-gmap> -->
                <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays"></p-gmap>

            </div>
            <div *ngIf="isJeLogin" class="my-2 proDataButton">
                <p class="invalid-feedback" *ngIf="geolocationsarray && geolocationsarray.length<4 && coordinateError">
                    {{coordinateError | translate}}</p>
                <button pButton pRipple type="submit" (click)="onCapture()"
                    label="{{'CAPTURE_GPS_COORDINATES' | translate}}" class="p-button-info mr-2 mb-2"></button>
                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation()"
                    label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}" class="p-button-info mr-2 mb-2"></button>
            </div>

        </div>
        <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
            <div class="field md:col-4 col-12">
                <label>{{'SURVEY_AREA'| translate}}: <label
                        [style]="{color: 'rgb(168, 32, 32)'}">{{surveyArea}}</label></label>
            </div>
            <div *ngIf="landArea > 0" class="field md:col-4 col-12">
                <label>{{'CALCULATED_AREA'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{landArea |
                        number : '1.2-2'}}</label></label>
            </div>
        </div>
        <div *ngIf="landArea - surveyArea > 1" class="p-fluid p-formgrid justify-content-center areaError mb-4"
            style="display: flex; flex-wrap:wrap">
            <p>{{ "CALCULATED_AREA_IS_MUCH_GREATER_THAN_SURVEYED_AREA._PLEASE_RECAPTURE_THE_COORDINATES" | translate }}
            </p>
        </div>
    </div>

    <div class="card block md:hidden">
        <h5 *ngIf="isJeLogin">{{'CAPTURE_IMAGE'| translate}}</h5>
        <h5 *ngIf="isXenLogin">{{'Captured Images'| translate}}</h5>
        <div *ngIf="isJeLogin" class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType"
                    placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}" optionLabel="name"
                    [showClear]="true"></p-dropdown>

            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}"
                    [disabled]="!selctedFileType" class="p-button-success mr-2 mb-2"></button>
            </div>
        </div>
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="word-break: break-word;display: flex;
                                justify-content: space-between">
                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i>
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block; width:200px">
                            </div>

                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)" class="video-align"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}"
                        class="p-button-success m-2" (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog>
    </div>


    <div class="card hidden md:block">
        <h5 *ngIf="isJeLogin">{{'CAPTURE_IMAGE'| translate}}</h5>
        <h5 *ngIf="isXenLogin">{{'Captured Images'| translate}}</h5>
        <div *ngIf="isJeLogin" class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType"
                    placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}" optionLabel="name"
                    [showClear]="true"></p-dropdown>

            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}"
                    [disabled]="!selctedFileType" class="p-button-success mr-2 mb-2"></button>
            </div>
        </div>
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="display: flex; justify-content: space-between">

                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i>
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block;">
                            </div>
                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}"
                        class="p-button-success m-2" (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog>
    </div>

    <div *ngIf="isXenLogin" class="mt-2 px-2 xen-remarks-card">
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-4">
                <label htmlFor="selectProgram">{{'Status of Application'| translate}}</label>
                <p-dropdown [options]="applicationStatusList" [(ngModel)]="XenRecommended" optionLabel="name"
                    optionValue="code" placeholder="{{'Select Status'| translate}}" appendTo="body">
                </p-dropdown>
            </div>

            <div class="field col-12 md:col-6">
                <textarea id="description" [(ngModel)]="xenRemarks" placeholder="{{'REMARKS'| translate}}"
                    pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
            </div>
        </div>
    </div>
    <button *ngIf="isJeLogin" pButton pRipple type="button" label="{{'SUBMIT'| translate}}" class="p-button-success m-2"
        style="float: right;" (click)="submitSurveyDetails()"></button>
    <button *ngIf="isXenLogin" pButton pRipple type="button" label="{{'SUBMIT'| translate}}"
        class="p-button-success m-2" style="float: right;" (click)="submitXenDetails()"></button>
</p-dialog>


<!-- <p-dialog header="" [(visible)]="displayUHBVNpvDialogForXEN" [modal]="true" [style]="{width: '85%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()">
    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedRow?.AppId }}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedRow?.Farmer_Name | uppercase }}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'PROG_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ selectedRow?.Program_Name }}</label></label>
        </div>
    </div>
</p-dialog> -->

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>